import chairman from "../../assets/images/chairman.jpg";
import dean from "../../assets/images/dean.jpg";
import director from "../../assets/images/director.jpg";

const Leadership = () => {
  return (
    <section className="faq-page py-60">
      <div className="container">
        <div className="text-center mb-40">
          <ul
            className="nav nav-pills common-tab d-inline-flex gap-16 bg-white p-12 border border-neutral-30 rounded-pill"
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8 active"
                id="pills-onlineEdu-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-onlineEdu"
                type="button"
                role="tab"
                aria-controls="pills-onlineEdu"
                aria-selected="true"
              >
                Chairman Message
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                id="pills-paymentMethod-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-paymentMethod"
                type="button"
                role="tab"
                aria-controls="pills-paymentMethod"
                aria-selected="false"
              >
                Dean Message
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8"
                id="pills-Pricing-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-Pricing"
                type="button"
                role="tab"
                aria-controls="pills-Pricing"
                aria-selected="false"
              >
                Director Message
              </button>
            </li>
          </ul>
        </div>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-onlineEdu"
            role="tabpanel"
            aria-labelledby="pills-onlineEdu-tab"
            tabIndex={0}
          >
            <div className="row gy-4">
              <div
                className="row align-items-center"
                style={{
                  background: "#f5f6fd",
                  padding: "20px",
                  borderRadius: "20px",
                }}
              >
                <div
                  className="col-xl-4 text-center"
                  data-aos="fade-up-left"
                  data-aos-duration="900"
                >
                  <img
                    src={chairman}
                    alt="Dr. K. P. Gopalkrishna, Chairman"
                    className="rounded-12"
                    style={{ height: 250, objectFit: "contain" }}
                    data-tilt=""
                    data-tilt-max={8}
                    data-tilt-speed={500}
                    data-tilt-perspective={5000}
                    data-tilt-full-page-listening=""
                  />
                  <h6 className="mt-3 mb-0 ">Dr. K. P. Gopalkrishna</h6>
                  <p className="mb-0" style={{ fontSize: 12 }}>
                    Chairman, NPS Group of Institutions, NAFL, and TISB
                  </p>
                </div>

                <div className="col-xl-8">
                  <div className="certificate__content">
                    <h3
                      className="mb-10 fw-medium"
                      data-aos="fade-up"
                      data-aos-duration="800"
                    >
                      A Message from Our Chairman
                    </h3>
                    <p
                      className="mb-0"
                      data-aos="fade-up"
                      data-aos-delay="120"
                      data-aos-duration="900"
                    >
                      Few things have greater importance to parents than the
                      education of their children. Every parent looks for
                      academic excellence, good values, and discipline for their
                      children. Choosing the right school for them is therefore
                      a crucial decision.
                      <br />
                      <br />
                      National Public School Kudlu provides high standards for
                      educational excellence to our students. We stimulate
                      creativity and develop problem-solving capability in each
                      student. As a family oriented school, we believe that
                      partnership between the family and school is the
                      foundation of a student’s fulfillment and success in later
                      life.
                      <br />
                      <br />
                      All the dynamic institutions in the world today look
                      forward to introducing and affecting a creative approach
                      in the educational curriculum. Teachers play a major role
                      in implementing and supporting the students to gain
                      competence in their efforts.
                      <br />
                      <br />
                      Our objective at National Public School – Best CBSE School
                      in Bangalore is to provide a happy, balanced and
                      challenging environment where our students have the
                      opportunity to fulfill their individual talents and goals.
                      In parallel, we provide a wide range of cultural, sporting
                      and co-curricular activities and a chance to exercise
                      leadership in a sensible and respectful environment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="pills-paymentMethod"
            role="tabpanel"
            aria-labelledby="pills-paymentMethod-tab"
            tabIndex={0}
          >
            <div className="row gy-4">
              <div
                className="row align-items-center"
                style={{
                  background: "#f5f6fd",
                  padding: "20px",
                  borderRadius: "20px",
                }}
              >
                <div
                  className="col-xl-4 text-center"
                  data-aos="fade-up-left"
                  data-aos-duration="900"
                >
                  <img
                    src={dean}
                    alt="Dr. Santhamma Gopalkrishna"
                    className="rounded-12"
                    style={{ height: 250, objectFit: "contain" }}
                    data-tilt=""
                    data-tilt-max={8}
                    data-tilt-speed={500}
                    data-tilt-perspective={5000}
                    data-tilt-full-page-listening=""
                  />
                  <h6 className="mt-3 mb-0 ">Dr. Santhamma Gopalkrishna</h6>
                  <p className="mb-0" style={{ fontSize: 12 }}>
                    Dean, NPS Group of Institutions, NAFL and TISB
                  </p>
                </div>

                <div className="col-xl-8">
                  <div className="certificate__content">
                    <h3
                      className="mb-10 fw-medium"
                      data-aos="fade-up"
                      data-aos-duration="800"
                    >
                      A Message from Our Dean
                    </h3>
                    <p
                      className="mb-0"
                      data-aos="fade-up"
                      data-aos-delay="120"
                      data-aos-duration="900"
                    >
                      Education has a multifaceted function. The transformation
                      from childhood to adulthood is an important one. Education
                      has a major role to play in this process.
                      <br />
                      <br />
                      In Swami Vivekananda’s words, “Education is not the amount
                      of information that is put in to your brain and runs riot
                      there, undigested all your life. We want that education,
                      by which character is formed, strength of mind is
                      increased, intellect is expanded and by which we can stand
                      on one’s own feet.”
                      <br />
                      <br />
                      All the dynamic institutions in the world today look
                      forward to introducing and affecting a creative approach
                      in the educational curriculum. Teachers play a major role
                      in implementing and supporting the students to gain
                      competence in their efforts.
                      <br />
                      <br />
                      In addition to acquisition of knowledge, education should
                      aim at physical, mental and spiritual development. There
                      should be opportunity for character formation and
                      personality development.
                      <br />
                      <br />
                      The training one gets from schools and colleges should
                      include academic excellence – professional, scientific and
                      technological – attainment of life skills and vocational
                      efficiency. The training should also help to manifest
                      innate potentialities making use of opportunities and
                      staying alert.
                      <br />
                      <br />
                      Progress of a country depends on its education system. In
                      this era of globalization it is necessary to understand
                      economic, social and political aspects of all the
                      countries. Practicing brotherhood, love and compassion
                      between different communities, races and nations is of
                      utmost importance. The emphasis on developing patriotism
                      and pride in one’s culture is indispensable.
                      <br />
                      <br />
                      Daniel Webster put it rightly “Knowledge does not comprise
                      all which is contained in the large term of education. The
                      feelings are to be disciplined, the passions are to be
                      restrained; true and worthy motives are to be inspired, a
                      profound religious feeling is to be instilled and pure
                      morality inculcated under all circumstances. All this is
                      comprised in education.”
                      <br />
                      <br />
                      Education in its true sense leads to health and fitness,
                      happy relationships, meaningful work and personal
                      fulfilment.
                      <br />
                      <br />
                      We at NPS try to promote an atmosphere where education is
                      a blend of progressive ideas from the best in the Indian
                      setting and culture. Students are given personal care and
                      support so that they take the right place in the Global
                      society.
                      <br />
                      Best wishes,
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="pills-Pricing"
            role="tabpanel"
            aria-labelledby="pills-Pricing-tab"
            tabIndex={0}
          >
            <div className="row gy-4">
              <div
                className="row mt-10 align-items-center"
                style={{
                  background: "#f5f6fd",
                  padding: "20px",
                  borderRadius: "20px",
                }}
              >
                <div
                  className="col-xl-4 text-center"
                  data-aos="fade-up-left"
                  data-aos-duration="900"
                >
                  <img
                    src={director}
                    alt="Dr. Bindu Hari"
                    className="rounded-12"
                    style={{ height: 250, objectFit: "contain" }}
                    data-tilt=""
                    data-tilt-max={8}
                    data-tilt-speed={500}
                    data-tilt-perspective={5000}
                    data-tilt-full-page-listening=""
                  />
                  <h6 className="mt-3 mb-0 ">Dr. K. P. Gopalkrishna</h6>
                  <p className="mb-0" style={{ fontSize: 12 }}>
                    Director, NPS Group of Institutions, NAFL, and TISB
                  </p>
                </div>

                <div className="col-xl-8">
                  <div className="certificate__content">
                    <h3
                      className="mb-10 fw-medium"
                      data-aos="fade-up"
                      data-aos-duration="800"
                    >
                      A Message from Our Director
                    </h3>
                    <p
                      className="mb-0"
                      data-aos="fade-up"
                      data-aos-delay="120"
                      data-aos-duration="900"
                    >
                      Every student comes to us with special goals, dreams and
                      expectations of what their future might hold.
                      <br />
                      <br />
                      We envision a school environment to help students achieve
                      their potential, offer guidance, hone their leadership
                      skills and foster in students the confidence to explore a
                      new range of interests, ultimately contributing positively
                      to the societies they live in. It is our belief that every
                      student in our school has the ability to succeed not just
                      academically but as individuals in their own unique ways.
                      <br />
                      <br />
                      An enthusiastic and professional body of faculty ensures
                      that excellence is promoted in all aspects of school life
                      along with special emphasis on life skills and lifelong
                      learning, in order to prepare students for life beyond
                      school.
                      <br />
                      <br />
                      We are proud of the strength of the partnership between
                      parents, staff and students which underpin the degree of
                      progress our students attain.
                      <br />
                      <br />
                      Through a combination of dedication, understanding and
                      appreciation, we encourage our students to aim high and
                      achieve their goals, in keeping with our motto – Reach
                      Out, Reach High and Reach Beyond.
                      <br />
                      Best wishes,
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Leadership;
